/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    {
      if: { hover: true },
      tokens: {
        backgroundColor: '#000000',
        borderColor: '#000000',
        iconColor: '#ffffff'
      }
    },
    {
      if: { pressed: true },
      tokens: {
        backgroundColor: '#404040',
        borderColor: '#404040',
        iconColor: '#ffffff'
      }
    }
  ],
  tokens: {
    backgroundColor: '#ffffff',
    borderColor: '#000000',
    borderRadius: 32,
    borderWidth: 1,
    iconColor: '#000000',
    iconScale: 1,
    iconSize: 16,
    iconTranslateX: 0,
    iconTranslateY: 0,
    outerBorderColor: 'transparent',
    outerBorderGap: 0,
    outerBorderWidth: 0,
    padding: 8,
    shadow: null
  }
}
export default theme
